import { Box } from "@mui/material";

export const PageContent = ({ children }) => {
  return <Box p={5}>{children}</Box>;
};
